import clsx from 'clsx';
import moment from 'moment';
import Tooltip from '@/components/Tooltip';

export default function ClassDatesBlocksList({ dates }) {
  const today = moment();

  return dates.map(({ date, time, timeEnd }) => {
    const d = moment(date, 'MM-DD-YYYY');
    const isBeforeToday = d.isBefore(today);

    const content = (
      <div
        key={date}
        className={clsx(
          'text-gray-900 border relative border-transparent rounded lg:rounded-lg bg-white w-24 flex flex-col items-center text-center py-4 px-5 space-y-1 focus:outline-none select-none mr-4',
          isBeforeToday === true &&
            'poiner-events-none opacity-60 ring-1 ring-black ring-opacity-10',
          isBeforeToday === false &&
            'cursor-pointer transition ease-in-out duration-100 hover:shadow-lg focus:ring-2 focus:ring-green-500 ring-1 ring-black ring-opacity-10 shadow hover:ring-opacity-20 focus:bg-green-50'
        )}
        tabIndex="-1"
      >
        {isBeforeToday && (
          <Tooltip tooltip="Clase no disponible">
            <button className="text-gray-300 hover:text-gray-500" type="button">
              <div className="absolute right-0 top-0 mr-2 mt-2">
                <svg
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </button>
          </Tooltip>
        )}
        <div className="text-gray-500 uppercase font-bold leading-none tracking-wide text-sm -mr-1">
          {d.format('MMM')}
        </div>
        <div className="uppercase text-4xl font-bold tracking-tighter leading-none">
          {d.format('DD')}
        </div>
        <div className="text-gray-600 font-bold text-xs leading-none tracking-wider whitespace-nowrap">
          {d.format('YYYY')}
        </div>
      </div>
    );

    if (isBeforeToday === true) {
      return content;
    }

    return <Tooltip tooltip={`${time} - ${timeEnd}`}>{content}</Tooltip>;
  });
}
